import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-anim-shop-phone',
  templateUrl: './anim-shop-phone.component.html',
  styleUrls: ['./anim-shop-phone.component.scss']
})
export class AnimShopPhoneComponent implements OnInit {

  // Données synchronisées avec la version Desktop pour cohérence
  boutiques = [
    {
      ville: 'Nancy',
      image: 'assets/img/boutiques/Nancy/boutiqueNancy.png', // J'ai ajouté 'assets/' par sécurité, vérifie tes chemins
      adresse: '19 Rue de la Faïencerie',
      horaires: 'Lun-Sam : 10h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/nancy']
    },
    {
      ville: 'Metz',
      image: 'assets/img/boutiques/Metz/boutiqueMetz.png',
      adresse: '11 Rue des Clercs',
      horaires: 'Lun-Sam : 10h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/metz']
    },
    {
      ville: 'Thionville',
      image: 'assets/img/boutiques/Thionville/P1129564.jpg',
      adresse: '23 Rue Brûlée',
      horaires: 'Mar-Sam : 10h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/thionville']
    },
    {
      ville: 'Pont-à-Mousson',
      image: 'assets/img/boutiques/PaM/P1129726.jpg',
      adresse: '41 Rue Victor Hugo',
      horaires: 'Mar-Sam : 10h-12h / 14h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/pont-a-mousson']
    },
    {
      ville: 'Semécourt',
      image: 'assets/img/boutiques/Semecourt/P1129504.jpg',
      adresse: 'Galerie Commerciale Auchan, Voie Romaine',
      horaires: 'Mar-Sam : 10h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/semecourt-semecourt']
    },
    {
      ville: 'Toul',
      image: 'assets/img/boutiques/Toul/P1129705.jpg',
      adresse: '14 Rue Dr Chapuis',
      horaires: 'Mar-Sam : 10h-19h',
      lien: ['https://lesanimationsdugobelin.com/animations/evenements/jeux-de-societe/toutes/toul']
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}